var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoNew = function SvgInfoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M7 6.02a.7.7 0 0 1 .7.7v3.262a.7.7 0 0 1-1.4 0V6.72a.7.7 0 0 1 .7-.7M7 5.068a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75"
  })));
};
export default SvgInfoNew;